import React from "react";
// React Router
import { useHistory } from "react-router-dom";
// Styled Components
import styled from "styled-components";
// Components
import VerticalCard from "../generic/VerticalCard";

const CardGrupoTrabajo = styled(VerticalCard).attrs(props => ({

  grayscale: props.active ? 0 : 100,
  shadow: props.active ? "0 0px 6px #2a599f !important" : "0 0px 6px #93a1b4 !important"

}))`
-webkit-filter: grayscale(${props => props.grayscale}); /* Safari 6.0 - 9.0 */
filter: grayscale(${props => props.grayscale});

  :hover {
    box-shadow: 0 0px 6px #2a599f !important;
  }
`;

const GrupoTrabajoTarjeta = ({ content, ...props }) => {
  let history = useHistory();

  let defaultImg = `/images/provincias/${content.provinceId}.png`;
  let img = content.photo ? `${process.env.REACT_APP_API_URL}/download/provincias/${content.provinceId}/gruposTrabajo/${content.id}` : defaultImg;

  return (
    <CardGrupoTrabajo
      onClick={(e) => {
        history.push(`gruposTrabajo/${content.id}`);
      }}
      cardImage={img}
      title={content.name}
      imgOnError={defaultImg}
      active={!content.endDate}
      {...props}
    />
  );
};

export default GrupoTrabajoTarjeta;
